import { request } from './index'

export const requestService = (url, method, params) => {
    if ('POST' === method) {
        return request.post(url, params);
    } else if ('GET' === method) {
        return request.get(url);
    }
    return {};
}